<template>
  <v-dialog v-model="dialog" :width="dialogWidth">
    <template v-slot:activator="{ on }">
      <slot v-bind:on="on" v-bind:disabled="!hasAdminRights">
        <v-icon v-on="on">
          mdi-delete
        </v-icon>
      </slot>
    </template>
    <v-card v-if="hasAdminRights">
      <v-card-title class="headline">
        {{
          $t(
            `Supprimer l'utilisateur ?`,
            `Supprimer les ${entities.length} utilisateurs ?`,
            entities.length
          )
        }}
      </v-card-title>
      <v-card-text>
        {{
          $t(
            `Confirmez la suppression de l'utilisateur ${entities[0].email}`,
            `Confirmez la suppresion des ${entities.length} utilisateurs sélectionnés.`,
            entities.length
          )
        }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" :disabled="loading" text @click="cancelDeletation">
          {{ $t("Annuler") }}
        </v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          text
          @click="confirmDeletation"
        >
          {{ $t("Oui, supprimer") }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <v-card-title class="headline">
        {{ $t(`Quelle action voulez-vous effectuer ?`) }}
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row class="row1">
            <v-col cols="12">
              <v-radio-group
                v-model="delegueRemoveUserReasons.reason1"
                hide-details="auto"
              >
                <v-radio
                  label="Désabonner l'utilisateur"
                  value="1"
                  color="primary"
                >
                </v-radio>
                <v-container class="sticky">
                  <v-row
                    class="reason-content level1"
                    v-if="delegueRemoveUserReasons.reason1 == 1"
                  >
                    <v-col cols="1"> </v-col>
                    <v-col cols="11">
                      <p>
                        Cela révoquera tous les droits de l'utilisateur liés à
                        l'observatoire.
                      </p>
                    </v-col>
                  </v-row>
                </v-container>

                <v-radio
                  label="Supprimer l'utilisateur"
                  value="2"
                  color="primary"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row class="row2">
            <v-col cols="1"></v-col>
            <v-col cols="11">
              <div
                class="reason-content level1"
                v-if="delegueRemoveUserReasons.reason1 == 2"
              >
                <v-radio-group
                  class="reason2"
                  v-model="delegueRemoveUserReasons.reason2"
                  hide-details="auto"
                >
                  <v-radio
                    label="Changement de société"
                    value="1"
                    color="primary"
                  ></v-radio>
                  <v-radio label="Autre" value="2" color="primary"></v-radio>
                </v-radio-group>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="delegueRemoveUserReasons.reason1 == 2" class="row3">
            <v-col cols="1"></v-col>
            <v-col cols="11">
              <v-text-field
                v-if="delegueRemoveUserReasons.reason2 == 1"
                v-model="delegueRemoveUserReasons.societeNew"
                :label="$t('Nouvelle société')"
                filled
                hide-details="auto"
              />
              <v-text-field
                v-if="delegueRemoveUserReasons.reason2 == 2"
                v-model="delegueRemoveUserReasons.other"
                :label="$t('Raison')"
                filled
                hide-details="auto"
              />
            </v-col>
          </v-row>
          <v-row class="warning-message row4" v-if="isContactMaj">
            <v-col cols="1" class="picto">
              <v-icon class="warning-message">mdi-alert</v-icon>
            </v-col>
            <v-col cols="11">
              <p>
                Cet adhérent est <b>contact de mise à jour</b> pour votre
                observatoire.<br />
                Merci de nous indiquer les coordonnées du nouveau contact de
                mise à jour.
              </p>
            </v-col>
          </v-row>
          <v-row
            v-if="isContactMaj"
            class="contact-miseajour"
            align="center"
            justify="center"
          >
            <v-col cols="7">
              <v-text-field
                v-model="delegueRemoveUserReasons.newContactMajDetails.nom"
                :label="$t('Nom complet')"
                filled
                class="field"
                :hide-details="isNameFilled"
                :error="!isNameFilled"
                :error-messages="isNameValidMessage"
                append-icon="mdi-account"
                @keyup="checkIsNameValid"
                @change="setNewContactMaj()"
              />
            </v-col>
            <v-col cols="7">
              <v-text-field
                v-model="delegueRemoveUserReasons.newContactMajDetails.email"
                :label="$t('Email')"
                filled
                type="email"
                class="field"
                :hide-details="isEmailValid"
                :error="!isEmailValid"
                :error-messages="isEmailValidMessage"
                append-icon="mdi-at"
                @keyup="checkIsEmailValid"
                @change="setNewContactMaj"
              />
            </v-col>
            <v-col cols="7">
              <v-text-field
                v-model="
                  delegueRemoveUserReasons.newContactMajDetails.telephone
                "
                :label="$t('N° téléphone')"
                filled
                type="tel"
                placeholder="## ## ## ## ##"
                class="field"
                hide-details="auto"
                append-icon="mdi-phone"
                @blur="formatPhone()"
                @change="setNewContactMaj()"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" :disabled="loading" text @click="cancelDeletation">
          {{ $t("Annuler") }}
        </v-btn>
        <v-btn
          :disabled="!validform"
          color="primary"
          :loading="loading"
          text
          @click="confirmDeletation"
        >
          {{ $t("Oui, supprimer") }}
        </v-btn>
        <!-- <v-tooltip text="Le nom et l'email sont obligatoire." top class="btn-tooltip">
          <template v-slot:activator="{ props }">
            <v-btn v-bind="props">Tooltip</v-btn>
          </template>
        </v-tooltip> -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import asyncForEach from "async-await-foreach";
import { createNamespacedHelpers } from "vuex";
import { DELETE_ONE, SEARCH } from "@/store/action-types";
import { User } from "@/models/User";
const { mapGetters: mapAuthGetters } = createNamespacedHelpers(`auth`);
const { mapActions: mapUserActions } = createNamespacedHelpers(`user`);
const { mapActions: mapUserSearchFormActions } = createNamespacedHelpers(
  `user/searchForm`
);
const { mapActions: mapCompanyActions } = createNamespacedHelpers(`company`);

export default {
  props: {
    entities: {
      type: Array,
      required: false,
      default: () => [new User()]
    }
  },
  data() {
    return {
      loading: false,
      dialog: false,
      isEmailValid: false,
      isEmailFilled: false,
      isNameFilled: false,
      delegueRemoveUserReasons: {
        reason1: "1",
        reason2: "1",
        societeNew: "",
        other: "",
        newContactMaj: "",
        newContactMajDetails: {
          nom: "",
          email: "",
          telephone: ""
        }
      }
    };
  },
  computed: {
    ...mapAuthGetters(["hasAdminRights"]),
    isContactMaj() {
      let isContactMaj = false;
      if (this.entities != null && this.entities.length > 0) {
        isContactMaj = this.entities[0].contactMiseAJour;
      }
      return isContactMaj;
    },
    dialogWidth() {
      return this.hasAdminRights ? 648 : 800;
    },
    validform() {
      let requiredFields = false;

      requiredFields =
        this.isNameFilled && this.isEmailFilled && this.isEmailValid;

      return !this.isContactMaj || requiredFields;
    },
    isEmailValidMessage() {
      let message = "";
      if (!this.isEmailFilled) {
        message = "L'adresse email est obligatoire.";
      } else if (!this.isEmailValid) {
        message = "Le format de l'adresse email n'est pas valide.";
      }
      let result = message == "" ? [] : [this.$t(message)];
      return result;
    },
    isNameValidMessage() {
      let message = "";
      if (!this.isNameFilled) {
        message = "Le nom est obligatoire.";
      }
      let result = message == "" ? [] : [this.$t(message)];
      return result;
    }
  },
  methods: {
    ...mapUserActions({
      delete: DELETE_ONE
    }),
    ...mapCompanyActions({
      searchField: SEARCH
    }),
    ...mapUserSearchFormActions({
      search: SEARCH
    }),
    async confirmDeletation() {
      this.$gtm.trackEvent({
        event: "interaction",
        category: "user",
        action: "Click (Confirmation suppression utilisateur)",
        label: "Confirmation suppression utilisateur"
      });

      this.loading = true;
      await asyncForEach(this.entities, async entity => {
        entity.delegueRemoveUserReasons = this.delegueRemoveUserReasons;
        await this.delete(entity);
      });
      await this.search();
      this.loading = false;

      this.$emit("success");

      this.dialog = false;
    },
    cancelDeletation() {
      this.$gtm.trackEvent({
        event: "interaction",
        category: "user",
        action: "Click (Annulation suppression utilisateur)",
        label: "Annulation suppression utilisateur"
      });

      this.dialog = false;
    },
    setNewContactMaj() {
      let reason = this.delegueRemoveUserReasons;
      let reasonDetail = reason.newContactMajDetails;
      reason.newContactMaj = `${reasonDetail.nom} ${reasonDetail.email} ${reasonDetail.telephone}`;
    },
    checkIsEmailValid() {
      let email = this.delegueRemoveUserReasons.newContactMajDetails.email;
      this.isEmailFilled = email.trim().length > 0;
      this.isEmailValid = /\S+@\S+\.\S+/.test(email);
    },
    checkIsNameValid() {
      let name = this.delegueRemoveUserReasons.newContactMajDetails.nom;
      this.isNameFilled = name.trim().length > 0;
    },
    formatPhone() {
      let phone = this.delegueRemoveUserReasons.newContactMajDetails.telephone;
      let pattern = "## ## ## ## ##";
      this.delegueRemoveUserReasons.newContactMajDetails.telephone = this.numberWithSpaces(
        phone,
        pattern
      );
      this.setNewContactMaj();
    },
    numberWithSpaces(value, pattern) {
      let phone = value.toString();
      let result = "";
      phone = phone.replaceAll(" ", "");

      for (let i = 0; i < phone.length; i++) {
        pattern = pattern.replace(/#/i, phone[i]);
      }
      result = pattern;
      return result;
    }
  },
  watch: {
    dialog(value) {
      if (value) {
        this.$gtm.trackEvent({
          event: "interaction",
          category: "user",
          action: "Click (Ouverture modal suppression utilisateur)",
          label: "Ouverture modal suppression utilisateur"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.v-expansion-panel-content.no-padding::v-deep {
  > .v-expansion-panel-content__wrap {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0;
  }
}

.reason-content {
  p {
    font-size: 12px;
    font-weight: bold;
  }
}
.sticky {
  padding: 0;
  .row {
    padding: 0;
    .col {
      padding-top: 0;
    }
  }
}
.reason2 {
  margin-top: 0px;
}

.warning-message {
  color: red;
  p {
    margin: 0;
  }
  .picto {
    text-align: right;
  }
}

.contact-miseajour {
  .col {
    padding-bottom: 0;
    padding-top: 0;
  }
}
</style>
